import moment from 'moment-timezone';

const isMonthlyMowingDisabled = (activeSeason) => {
    if (
        !activeSeason ||
        !activeSeason.mowingMonthlyDisabledStartsAt ||
        !activeSeason.mowingMonthlyDisabledEndsAt
    ) {
        return false;
    }

    const { mowingMonthlyDisabledStartsAt, mowingMonthlyDisabledEndsAt } = activeSeason;
    return moment().isBetween(mowingMonthlyDisabledStartsAt, mowingMonthlyDisabledEndsAt);
};

//eslint-disable-next-line import/prefer-default-export
export { isMonthlyMowingDisabled };
